export const menuNames = {
  RAG: 'Recommend a grant',
  GA: 'Grant Agreements',
  MAC: 'Make a contribution',
  RAE: 'Recommend an exchange'
};

export const menuConfig = [
  {
    name: 'DASHBOARD',
    link: '/financialadvisor',
    className: '',
    childNode: []
  },
  {
    name: 'ACCOUNT SUMMARY',
    link: '/',
    className: '',
    childNode: []
  },
  {
    name: 'GRANTS',
    link: null,
    className: 'tool-tip',
    childNode: [
      {
        name: 'Grant Overview',
        link: '/grants',
        childNode: [],
        className: '',
      },
      {
        name: 'Recommend a grant',
        link: '/grants/recommend',
        childNode: [],
        className: '',
        access: 'Read Only'
      },
      {
        name: 'Grant Agreements',
        link: '/grants/agreement',
        childNode: [],
        className: '',
        access: 'Read Only'
      },
      {
        name: 'Grant Activity',
        link: '/grants/activity',
        childNode: [],
        className: '',
        access: 'All Access'
      },
      {
        name: 'Find Charity',
        link: '/grants/find-charity',
        childNode: [],
        className: '',
        access: 'All Access'
      },
      {
        name: 'How it works',
        link: '/grants/how-it-works',
        childNode: [],
        className: '',
        access: 'All Access'
      },
      {
        name: 'Grants_Header',
        link: '',
        childNode: [],
        className: 'header-hide',
        access: 'none'
      }
    ]
  },
  {
    name: 'CONTRIBUTIONS',
    className: 'tool-tip',
    link: null,
    childNode: [
      {
        name: 'Contribution Overview',
        link: '/contributions',
        childNode: [],
        className: '',
      },
      {
        name: 'Make a contribution',
        link: '/contributions/make-a-contribution',
        childNode: [],
        className: '',
        access: 'Read Only'
      },
      {
        name: 'Contribution Activity',
        link: '/contributions/activity',
        childNode: [],
        className: '',
        access: 'All Access'
      },
      {
        name: 'Contributions_Header',
        link: '',
        childNode: [],
        className: 'header-hide',
        access: 'All Access'
      }
    ]
  },
  {
    name: 'INVESTMENTS',
    className: '',
    link: null,
    childNode: [
      {
        name: 'Investment Overview',
        link: '/investments',
        childNode: [],
        className: '',
      },
      {
        name: 'Recommend an exchange',
        link: '/investments/recommend-an-exchange',
        childNode: [],
        className: '',
        access: 'All Access'
      },
      {
        name: 'Exchange Activity',
        link: '/investments/exchange-activity',
        childNode: [],
        className: '',
        access: 'All Access'
      },
      {
        name: 'Investment option details',
        link: '/investments/details',
        childNode: [],
        className: '',
        access: 'All Access'
      },
      {
        name: 'Investment_Header',
        link: '',
        childNode: [],
        className: 'header-hide',
        access: 'none'
      }
    ]
  },
  {
    name: 'MY ACCOUNT',
    className: '',
    link: null,
    childNode: [
      {
        name: 'Account Details',
        link: '/my-account',
        childNode: [],
        className: '',
      },
      {
        name: 'My Documents',
        link: '/my-account/my-documents',
        childNode: [],
        className: '',
        access: 'All Access'
      },
      {
        name: 'Transaction Summary',
        link: '/my-account/transaction-summary',
        childNode: [],
        className: '',
        access: 'All Access'
      },
      {
        name: 'My_Account_Header',
        link: '',
        childNode: [],
        className: 'header-hide',
        access: 'none'
      }
    ]
  },
  {
    name: 'CSR',
    link: '#',                 
    childNode: [
        {
            name: 'CSR Account Activity',
            link: 'accountActivity.do',
            childNode: [],
            className:'hoverColoring',
            access: 'All Access'
        },
        {
            name: 'CSR Account Snapshot',
            link:'getSnapshot.do',
            childNode: [],
            className:'hoverColoring',
            access: 'All Access'
        },
        {
            name: 'CSR_Header',
            link: '',
            childNode: [],
            className:'header-hide',
            access: 'none'
        }
    ]
  }
];

export const faConfig = [
  {
    name: 'DASHBOARD',
    link: '/financialadvisor',
    className: '',
    childNode: []
  },
  {
    name: 'PROFILE',
    link: '/my-profile',
    className: '',
    childNode: []
  },
  {
    name: 'ADVISOR RESOURCES',
    link: '/advisor-resources',
    className: '',
    childNode: []
  },
  {
    name: 'CSR',
    link: '#',                 
    childNode: [
        {
            name: 'CSR Account Activity',
            link: 'accountActivity.do',
            childNode: [],
            className:'hoverColoring',
            access: 'All Access'
        },
        {
            name: 'CSR Account Snapshot',
            link:'getSnapshot.do',
            childNode: [],
            className:'hoverColoring',
            access: 'All Access'
        },
        {
            name: 'CSR_Header',
            link: '',
            childNode: [],
            className:'header-hide',
            access: 'none'
        }
    ]
  }
];
